import React from "react";
import { Image, Col, Row } from "react-bootstrap";
import { AddButtonIconComponent } from "../../../../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import { SliderReusableComponent } from "../../../../../../reusableComponents/sliderReusableComponent/SliderReusableComponent";
import { BackLogoIconButton } from "../../../../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
import {
  ReusableOnboardingButton,
  ReusableOnboardingLink,
  ReusableOnboardingMapButton,
} from "../../../../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import { TopTextReusableComponent } from "../../../../../reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import { IconButton } from "@material-ui/core";
import { useHistory } from "react-router-dom";

export const FastFoodCrossSelling = (props) => {
  const history = useHistory();
  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div
            id="onboarding-scrollbar"
            className="p-lg-0 col-12 col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 onboarding_process_screen_left new-subscription-onboarding-component"
          >
            <div className="col-12">
              <BackLogoIconButton
                displayBackText={true}
                displayArrow={true}
                backButtonClicked={
                  history.location.pathname.includes("admin")
                    ? "/admin-fastfood/menusetup"
                    : "/fastfood/menusetup"
                }
              />
            </div>
            <div className="onboarding_process_screen-button-map d-flex justify-content-between flex-column">
              <div>
                <TopTextReusableComponent
                  headingText="Map Categories for Cross Selling"
                  headingParagraph="(You can match categories by selecting categories, items in cross Selling category are proposed at the time of cart during ordering)"
                />
              </div>

              <div className="f20-500 mt-4">Cross Selling</div>
              <div className="f11-400 mb-4" style={{ color: "#9e9e9e" }}>
                Add all your Menu Categories to move ahead with the Menu Set Up
                Process
              </div>
              <div className="f14-500 mb-4">Category Type</div>
              <div className={"cuisine-main-padding-border"}>
                <div className="cuisine-main-padding d-flex flex-wrap">
                  <ReusableOnboardingMapButton
                    classsection={
                      "mr-3 mb-3 onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type onboarding_mapbutton_reusable_activesingle"
                    }
                    src={require("../../../../../../../assets/images/Icon/beverage.png")}
                    title={"Food"}
                    // onClick={this.onSelectedServeLiquorArraySelector(icon)}
                  />
                  <ReusableOnboardingMapButton
                    classsection={`mr-3 mb-3 onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type `}
                    // src={require("../../../../../../../assets/images/Icon/beverage.png")}
                    title={"Alcohol"}
                  />
                </div>
              </div>
              <hr />
              <div className="f14-500 mb-4">Cross Selling Category Type</div>
              <div className={"cuisine-main-padding-border"}>
                <div className="cuisine-main-padding d-flex flex-wrap">
                  <ReusableOnboardingMapButton
                    classsection={
                      "mr-3 mb-3 onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type onboarding_mapbutton_reusable_activesingle"
                    }
                    src={require("../../../../../../../assets/images/Icon/beverage.png")}
                    title={"Food"}
                    // onClick={this.onSelectedServeLiquorArraySelector(icon)}
                  />
                  <ReusableOnboardingMapButton
                    classsection={`mr-3 mb-3 onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type `}
                    // src={require("../../../../../../../assets/images/Icon/beverage.png")}
                    title={"Alcohol"}
                  />
                </div>
              </div>
              <div className="onboarding-map-setup-screen-autodetect-button justify-content-between mt-5">
                <ReusableOnboardingLink
                  buttonTitle="Back Button"
                  buttonClass="btn-lg btn btn-outline-secondary"
                  buttonText="Cancel"
                  link="/subscription"
                />
                <ReusableOnboardingButton
                  buttonTitle="Next Button"
                  buttonClass="btn-lg btn btn-danger btn-lg ml-3 "
                  buttonText="Save and Add Another"
                  buttonType="Submit"
                />
                <ReusableOnboardingButton
                  buttonTitle="Next Button"
                  buttonClass="btn-lg btn btn-danger btn-lg ml-3 "
                  buttonText="Proceed"
                  buttonType="Submit"
                />
              </div>
              <div className="f12-400 py-4">
                * Scroll down to see cross Selling Matches created
              </div>
              <Row className="align-items-center">
                <Col md={4}>
                  <div className="f14_700_HelveticaNeue py-2">
                    Main Category
                  </div>
                </Col>
                <Col md={3}>
                  <div className="f14_700_HelveticaNeue py-2">Section</div>
                </Col>
              </Row>
              <Row className="align-items-center border-bottom">
                <Col md={4}>
                  <div className="f12-400 py-2">1) Soup</div>
                </Col>
                <Col md={5}>
                  <div className="f12-400 py-2">Alcohol, Beverages, Juice</div>
                </Col>
                <Col md={3}>
                  <div className="d-flex align-items-center">
                    <IconButton className="mr-2">
                      <Image
                        src={require("../../../../../../../assets/images/UserManagement/editBlue.svg")}
                        alt="add"
                        title="add"
                        className="w-20px"
                      />
                    </IconButton>
                    <IconButton>
                      <Image
                        src={require("../../../../../../../assets/images/UserManagement/delete-gray.svg")}
                        alt="add"
                        title="add"
                        className="w-20px"
                      />
                    </IconButton>
                  </div>
                </Col>
              </Row>
              <Row className="align-items-center border-bottom">
                <Col md={4}>
                  <div className="f12-400 py-2">2) Soup</div>
                </Col>
                <Col md={5}>
                  <div className="f12-400 py-2">Alcohol, Beverages, Juice</div>
                </Col>
                <Col md={3}>
                  <div className="d-flex align-items-center">
                    <IconButton className="mr-2">
                      <Image
                        src={require("../../../../../../../assets/images/UserManagement/editBlue.svg")}
                        alt="add"
                        title="add"
                        className="w-20px"
                      />
                    </IconButton>
                    <IconButton>
                      <Image
                        src={require("../../../../../../../assets/images/UserManagement/delete-gray.svg")}
                        alt="add"
                        title="add"
                        className="w-20px"
                      />
                    </IconButton>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
          <div className="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 loginsignup-rightside">
            <SliderReusableComponent
              // displayBarButton={true}
              displayHamburger={true}
              paragraphOne="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
              paragraphTwo="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
              paragraphThree="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
              bottomImage={require("../../../../../../../assets/images/illustratorImage/Amealio_Illustrations-01.svg")}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
